import { FC, useMemo } from "react";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK_WHITE = `${process.env.PUBLIC_URL}/images/logos/logo-mark-white.webp`;

const WidgetTemplate6: FC<IWidgetTemplate> = ({ company, score, theme }) => {
  const isDark = theme === "dark";
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 6 as const }),
    [companyId],
  );

  const companyUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=micro-button`,
    [companyId],
  );

  return (
    <a
      className={`text-decoration-none${isDark ? " text-white" : ""}`}
      style={{ color: "unset" }}
      href={companyUrl}
      target="_blank"
      rel="noreferrer noopener"
      onClick={() => ReachClick(payload)}
    >
      <div className="overflow-hidden d-flex justify-content-center">
        <div
          className={`d-flex align-items-center border bg-primary p-2${
            isDark ? " border-secondary" : ""
          }`}
        >
          <img
            src={LOGO_MARK_WHITE}
            alt="TrustFinance"
            width={19}
            height={19}
          />
          <span className="fs-11 text-white">TrustFinance</span>
        </div>
        <div
          className={`border border-start-0 fs-11 d-flex align-items-center p-2${
            isDark ? " border-secondary" : ""
          }`}
        >
          {score?.totalReview} Reviews
        </div>
      </div>
    </a>
  );
};

export default WidgetTemplate6;
